import React from "react";

interface IProps {
  resource: number;
  icon: string;
  race: string;
  first?: boolean;
  select?: any;
  selected?: boolean;
}

const ResourceSquare = (props: IProps) => (
  <div
    className={
      `col-md-1 ${props.first ? "col-xs-offset-1" : ""} person new-item ${props.resource > 0 ? "white" : "disabled"} `
      + `${props.selected ? "selected" : ""} ${props.selected ? props.race : ""}`
    } data-toggle="select-person"
    data-rid="2"
    data-res="grain"
    onClick={props.select}
  >
    <i className={`icon icon-xmd icon-standalone icon-${props.icon}`}/>
  </div>
);

export default ResourceSquare;
